import { useState } from 'react';
import { FieldProps } from '@rjsf/core';
import { JSONSchema7 } from 'json-schema';
import { chevronRightBlack } from '../../assets/images';

const CollapsibleFieldTemplate = (props: FieldProps) => {
    const { idSchema, formData } = props;
    const [expanded, setExpanded] = useState(false);
    const { SchemaField } = props.registry.fields;

    const label =
        formData?.label ||
        formData?.name ||
        formData?.id ||
        idSchema?.$id?.split('_').pop() ||
        'Item';

    return (
        <div className="collapsible-accordion-item">
            <div className="collapsible-accordion-header" onClick={() => setExpanded(!expanded)}>
                <img
                    className={`toggle-icon ${expanded ? 'close-toggle-icon' : ''}`}
                    src={chevronRightBlack}
                    alt="toggle-icon"
                />
                <span>{label}</span>
            </div>
            {expanded && (
                <div className="collapsible-accordion-body" style={{ padding: '10px' }}>
                    {Object.keys(props.schema.properties || {}).map((key) => {
                        return (
                            <SchemaField
                                key={key}
                                name={key}
                                id={`${idSchema.$id}_${key}`}
                                required={props.schema.required?.includes(key)}
                                schema={props.schema?.properties?.[key] as JSONSchema7}
                                uiSchema={props.uiSchema[key] || {}}
                                formData={formData[key]}
                                onChange={(value: any) => {
                                    const newFormData = { ...formData, [key]: value };
                                    props.onChange(newFormData);
                                }}
                                registry={props.registry}
                                errorSchema={props.errorSchema[key] || {}}
                                idSchema={props.idSchema[key] || { $id: `${idSchema.$id}_${key}` }}
                                formContext={props.formContext}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default CollapsibleFieldTemplate;
